import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import {
  adminDeleteSpecificCheckpoint,
  getDocumentCheckpoint,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBarCheckpoint/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetSCCountriesListManagement,
  adminGetSCStatesListManagement,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
  getSmartFilterListManagementList,
  getSmartFilterSCCategoryOfLawList,
  getSmartFilterSCLegislationList,
  getSmartFilterSCLegislationRuleList,
} from "@services/list-management.service";
import Notfound from "@components/Not-Found";
import {
  adminBulkUpdateStatus,
  adminGetUsers,
  getEvaluatorUsers,
  getExecutorUsers,
  getFunctionHeadUsers,
} from "@services/users.service";
import {
  UpdateMultipleSelfComplianceTask,
  UpdateSelfComplianceTask,
  bulkUpdateSelfComplianceTask,
  getSelfComplianceTaskList,
  updateSelfComplianceListStatus,
} from "@services/self-compliance.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { formatText } from "@_common/format-text";
import AssignTaskFilterForm from "@components/common/AddFilter/AssignTaskFilterForm";
import {
  getChildEntityGroups,
  getEntityGroups,
  getSCChildEntityGroups,
} from "@services/entity-mapping.service";
import {
  NewDate,
  convertCurrentDate,
  convertCurrentDateWithTime,
  convertDate,
  convertDateAsString,
  todayDate,
} from "@_common/date-helpers";
import DatePicker from "react-datepicker";
import InputField from "@_common/InputRuleFeild";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import { clientAdminFileUpload } from "@services/client-list.service";
import { concatDotToString, countKeysWithValues } from "@_common/text-helpers";
import { tableStatusStyle } from "@_common/colors";
import { handleDownloadOnClick } from "@_common/downloadfile";
import SelfComplianceUpdatePopup from "@components/common/SelfComplianceDetail/UpdateTaskPopup";
import { downloadSelfComplianceReports } from "@services/import.service";
import FooterWrapper from "@components/common/FooterWrapper";
import EvaluatorApprovalNotfound from "@components/Page-Not-Found/evaluator-approval-not-found";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ModuleFilter from "@components/common/ModuleFilter";
import SubmenuArrowDownSvgComponent from "../../../assets/svg-components/left-menu/submenu-arrow-down";
import DocumentStorePopup from "@components/common/SelfComplianceDetail/documentStore";
import ConfirmModalTask from "@_common/ConfirmModalTask";
import { getLegacyTaskList } from "@services/email-template.service";
import ActivitiesEvaluatorTaskNotfound from "@components/Page-Not-Found/activities-evaluator-task-not-found";

interface ICheckpointActiveProps {}

const ActivitiesPendingApprovalTask: React.FunctionComponent<
  ICheckpointActiveProps
> = (props: any) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [filterOptions] = useState([
    { value: "DRAFT", label: "Draft" },
    { value: "ACTIVE", label: "Active" },
    { value: "ARCHIVED", label: "Archived" },
  ]);
  const [complianceStatusOptions] = useState([
    // { value: "ASSIGNED", label: "Assigned" },
    // { value: "POSING", label: "Posing" },
    // { value: "COMPLIED", label: "Complied" },
    // { value: "NON_COMPLIED", label: "Non Complied" },
    // { value: "DELAYED", label: "Delayed" },
    // { value: "DELAYED_REPORTED", label: "Delayed Reported" },
    // { value: "RE_OPENED", label: "Re Opened" },
    { value: "EVENT_NOT_OCCURED", label: "Event Not Occured" },
    // { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
    // { value: "REPORTED_NON_COMPLIED", label: "Reported Non Complied" },
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    getPEComplianceList();
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getDataLegacyTask();
      getCountriesList();
      getSmartFilterList();
      getHeaderList(paramsObj, 0);
      getExecutorList("", "");
      getEvaluator("", "");
      getFunctionHead("", "");

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);

      getCategoryLawList("", "", "");
      getLegislationList("", "", "", "");
      getLegislationRuleList("", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getDataLegacyTask();
      getCountriesList();
      getSmartFilterList();
      getExecutorList("", getValue(params, `executor`, ""));
      getEvaluator("", getValue(params, `evaluator`, ""));
      getFunctionHead("", getValue(params, `function_head`, ""));
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      setRequest({
        ...request,
        country_id: getValue(params, `country_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        executor: getValue(params, `executor`, ""),
        evaluator: getValue(params, `evaluator`, ""),
        function_head: getValue(params, `function_head`, ""),
        compliance_status: getValue(params, `compliance_status`, ""),
        status: getValue(params, `status`, ""),
      });
      if (
        getValue(params, `country_id`, "") ||
        getValue(params, `level1`, "")
      ) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
          getValue(params, `legislation_id`, ""),
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, ""),
        );
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "", "");
        getLegislationRuleList("", "", "");
      }

      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      } else if (params.firstDay && params.lastDay) {
        // setDate(new Date(params.date));
        var owner_due_date_from = new Date(params.firstDay);
        var owner_due_date_to = new Date(params.lastDay);
        setFirstDay(owner_due_date_from);
        setLastDay(owner_due_date_to);
      }

      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
    }
  }, [window.location.href, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getPayload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      // from_date: getValue(params, `request_value`, "")
      //   ? ""
      //   : convertDate(from_date),
      // to_date: getValue(params, `request_value`, "")
      //   ? ""
      //   : convertDate(to_date),
      // from_date: convertDate(from_date),
      // to_date: convertDate(to_date),
      // from_date : getValue(params, `request_from`, "") === "DASHBOARD"
      //   ? ""
      //   : convertDate(from_date),

      // to_date : getValue(params, `request_from`, "") === "DASHBOARD"
      //   ? ""
      //   : convertDate(to_date),

      ...(params.is_all_time === "true"
        ? { show_till_date: true }
        : params.is_evaluator_date
          ? {
              approver_due_date_from:
                getValue(params, `request_from`, "") === "DASHBOARD"
                  ? ""
                  : convertDate(from_date),
              approver_due_date_to:
                getValue(params, `request_from`, "") === "DASHBOARD"
                  ? ""
                  : convertDate(to_date),
            }
          : {
              from_date:
                getValue(params, `request_from`, "") === "DASHBOARD"
                  ? ""
                  : convertDate(from_date),
              to_date:
                getValue(params, `request_from`, "") === "DASHBOARD"
                  ? ""
                  : convertDate(to_date),
            }),

      compliance_status: getValue(params, `compliance_status`, ""),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      sort_by: params.sort_by,
      search_text: params.search_text,
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      self_compliance_task_ids: compliance_task_ids,
      smart_filter_tags: selectedIDs,
      status: getValue(params, `status`, "")
        ? getValue(params, `status`, "")
        : "active",
      request_from:
        getValue(compliance_task_ids, `length`, 0) > 0
          ? ""
          : getValue(params, `request_from`, "")
            ? getValue(params, `request_from`, "")
            : "PENDING_APPROVAL",
      // request_from:
      // getValue(compliance_task_ids, `length`, 0) > 0
      //   ? ""
      //   : getValue(params, `request_from`, "")
      //   ? getValue(params, `request_from`, "")
      //   : "EVALUATOR",
      dashboard_type: getValue(params, `dashboard_type`, ""),
      value: getValue(params, `value`, ""),
      request_user: getValue(params, `request_user`, ""),
    };
    return { ...payload };
  };

  const [licenseIDs, setLicenseIDs] = useState([]);
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    // console.log(getValue(params, `request_type`, "") === "APPROVAL_STATS");
    // let dates = params.date ? new Date(params.date) : new Date();
    // var from_date = params.from_date
    //   ? params.from_date
    //   : new Date(dates.getFullYear(), dates.getMonth(), 1);
    // var to_date = params.to_date
    //   ? params.to_date
    //   : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    // let payload: any = {
    //   from_date:
    //     getValue(params, `request_type`, "") === "APPROVAL_STATS"
    //       ? ""
    //       : convertDate(from_date),
    //   to_date:
    //     getValue(params, `request_type`, "") === "APPROVAL_STATS"
    //       ? ""
    //       : convertDate(to_date),
    //   page_no: params.page_no ? parseInt(params.page_no) : 1,
    //   page_size: params.limit ? parseInt(params.limit) : limit,
    //   search_text: params.search_text,
    //   // status: "active",
    //   sort_by: params.sort_by,
    //   country_id: parseInt(getValue(params, `country_id`, "")),
    //   state_id: parseInt(getValue(params, `state_id`, "")),
    //   category_of_law_id: await getSpecificCategoryLawById(
    //     getValue(params, `category_of_law_id`, "")
    //   ),
    //   legislation_id: getValue(params, `legislation_id`, ""),
    //   legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
    //   event_id: parseInt(getValue(params, `event_id`, "")),
    //   sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
    //   smart_filter_tags: selectedIDs,
    //   compliance_type_id: getValue(params, `compliance_type_id`, ""),
    //   executor: getValue(params, `executor`, ""),
    //   evaluator: getValue(params, `evaluator`, ""),
    //   function_head: getValue(params, `function_head`, ""),
    //   compliance_status: getValue(params, `compliance_status`, ""),
    //   request_from: getValue(params, `request_from`, "")
    //     ? getValue(params, `request_from`, "")
    //     : "PENDING_APPROVAL",
    //   request_type: getValue(params, `request_type`, "")
    //     ? getValue(params, `request_type`, "")
    //     : "",
    //   request_value: getValue(params, `request_value`, "")
    //     ? getValue(params, `request_value`, "")
    //     : "",
    //   status: getValue(params, `status`, "")
    //     ? getValue(params, `status`, "")
    //     : "active",
    // };

    let payload: any = {
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // category_of_law_id: await getSpecificCategoryLawById(
      //   getValue(params, `category_of_law_id`, "")
      // ),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),

      request_type: getValue(params, `request_type`, "")
        ? getValue(params, `request_type`, "")
        : "",
      request_value: getValue(params, `request_value`, "")
        ? getValue(params, `request_value`, "")
        : "",
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      status: getValue(params, `status`, "")
        ? getValue(params, `status`, "")
        : "active",
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_",
        )[0];
      }
    }
    let payloadObj = await getPayload();
    let queryRequest = QueryRequestHelper({
      ...payload,
      ...levelObj,
      ...payloadObj,
    });

    // let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    try {
      setIsLoading(true);
      let resp = await getSelfComplianceTaskList(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.compliance_tasks`, []).map((item: object) => ({
            ...item,
            task_id: getValue(item, `task_id`, ""),
            category_of_lawName: getValue(item, `category_of_law.text`, ""),
            compliance_typeName: getValue(item, `compliance_type.text`, ""),
            frequencyName: getValue(
              item,
              `self_compliance.checkpoint.frequency.text`,
              "",
            ),
            compliance_activity: getValue(item, `compliance_activity`, ""),
            legislationName: getValue(
              item,
              `self_compliance.checkpoint.legislation.legislation_name`,
              "",
            ),
            reference: getValue(
              item,
              `self_compliance.checkpoint.reference`,
              "",
            ),
            who: getValue(item, `self_compliance.checkpoint.who`, ""),
            when: getValue(item, `self_compliance.checkpoint.when`, ""),
            frequency: getValue(
              item,
              `self_compliance.checkpoint.frequency.text`,
              "",
            ),
            legislation_ruleName: getValue(
              item,
              `self_compliance.checkpoint.legislation_rule.rule_name`,
              "",
            ),
            activation_status: formatText(
              getValue(item, `activation_status`, ""),
            ),
            compliance_status_formatted: formatText(
              getValue(item, `compliance_status`, ""),
            ),
            work_status_formatted: formatText(
              getValue(item, `work_status`, ""),
            ),
            configure: getValue(item, `is_configured`, "")
              ? "Configured"
              : "Not Configured",
            legal_due_date: convertCurrentDate(
              getValue(item, `legal_due_date`, ""),
            ),
            created_at: convertCurrentDateWithTime(
              getValue(item, `created_at`, ""),
            ),
            executor_date: convertCurrentDate(
              getValue(item, `owner_due_date`, ""),
            ),
            executor_completion_date: convertCurrentDate(
              getValue(item, `executor_completion_date`, ""),
            ),
            executor_comments: getValue(item, `remarks`, ""),
            procedure: getValue(
              item,
              `self_compliance.checkpoint.procedure`,
              "",
            ),
            impact: getValue(
              item,
              `self_compliance.checkpoint.impact.text`,
              "",
            ),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            executor_name:
              getValue(item, "executor.first_name", "") +
              " " +
              getValue(item, "executor.last_name", ""),
          })),
        );
        let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
          (item: object) =>
            getValue(item, `compliance_type.text`, "") === "License",
        );
        setLicenseIDs(
          getValue(licenseIDs, `length`, 0) > 0
            ? licenseIDs.map((item: any) => item.id)
            : [],
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [hasLegacyTask, setHasLegacyTask] = useState(false);
  const getDataLegacyTask = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    try {
      let payload = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        status: params.status,
        request_from: "EVALUATOR",
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getLegacyTaskList(queryRequest);
      if (resp) {
        setHasLegacyTask(getValue(resp, `data.tasks.length`, 0) > 0);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [docStoreData, setDocStoreData] = useState<any>([]);

  const getDocumentStoreData = async (id: string) => {
    let getDocStorepayload: any = {
      checkpoint_id: id,
    };
    let docStoreResp = await getDocumentCheckpoint(getDocStorepayload);
    if (docStoreResp) {
      handleDocumentStore();
      setDocStoreData(getValue(docStoreResp, `data.checkpoints`, []));
    }
  };

  const handleUpdateStatus = async (value: string) => {
    try {
      let payload = {
        ids: selectedIDs,
        activation_status: value,
      };
      let resp = await updateSelfComplianceListStatus(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };
  const handleChangeSearch = async (e: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setSearchInput(e.target.value);

    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {}),
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index),
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, "")),
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  // const handleDeleteFun = (id: string, value: string) => {
  // 	setDeleteValue(value);
  // 	setDeleteId(id);
  // 	handleDelete();
  // };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  // const handleChangeSortBy = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.sort_by = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };

  // const handleChangeStatus = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.status = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    if (
      getValue(obj, `original.id`, "") &&
      getValue(obj, `original.self_compliance.checkpoint.id`, "")
    ) {
      navigate(
        `/activities/self-compliance/pending-approval/task-details/${getValue(
          obj,
          `original.id`,
          "",
        )}/${getValue(
          obj,
          `original.self_compliance.checkpoint.id`,
          "",
        )}?${mainQueryRequest}`,
      );
    } else {
      toast.error("Checkpoint not available");
    }
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
  };
  const onPrem = getValue(localStorage, `op`, "") === "true";

  const columns = React.useMemo(
    () => [
      {
        Header: "Task ID",
        accessor: "task_id",
        width: 140,
        Cell: ({ row }: any) => {
          const isInterlinked = getValue(
            row.original,
            `self_compliance.interlinked_checkpoint.id`,
            null,
          );
          return (
            <>
              <NavLink to={`#`}>
                {getValue(row, `original.task_id`, "") + " "}
              </NavLink>
              {isInterlinked && (
                <img
                  src="/images/interlinked_icon.png"
                  className="img-fluid add-filter-wrapper__upload-image"
                  alt="interlinked_task_icon"
                  width={"24px"}
                />
              )}
            </>
          );
        },
      },
      // {
      // 	Header: "Category of Law",
      // 	accessor: "category_of_lawName",
      // 	width: 250,
      // },
      {
        Header: "Legislation",
        accessor: "legislationName",
        width: 350,
      },
      {
        Header: "Rule",
        accessor: "legislation_ruleName",
        width: 350,
      },

      {
        Header: "Reference",
        accessor: "reference",
        width: 250,
      },
      {
        Header: "Who",
        accessor: "who",
        width: 150,
      },
      {
        Header: "When",
        accessor: "when",
        width: 180,
      },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 350,
        Cell: ({ row }) => {
          const complianceActivity = getValue(
            row.original,
            `self_compliance.checkpoint.compliance_activity`,
            "",
          );

          const maxCharCount = 100;
          const [showFullContent, setShowFullContent] = useState(false);

          const toggleContent = (e: any) => {
            e.stopPropagation();
            setShowFullContent(!showFullContent);
          };

          const truncatedContent = complianceActivity
            ? complianceActivity.slice(0, maxCharCount)
            : "";
          return (
            <div>
              {showFullContent ? complianceActivity : truncatedContent}
              {getValue(complianceActivity, `length`, 0) > maxCharCount && (
                <span onClick={toggleContent}>
                  {showFullContent ? (
                    <span style={{ color: "#276ef1" }}>
                      {" "}
                      View less{" "}
                      <span
                        style={{
                          transform: "rotate(180deg)",
                          display: "inline-block",
                        }}
                      >
                        {" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  ) : (
                    <span>
                      {" "}
                      ...{" "}
                      <span style={{ color: "#276ef1" }}>
                        View more{" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  )}
                </span>
              )}
            </div>
          );
        },
      },
      // {
      //   Header: "Procedure",
      //   accessor: "procedure",
      //   width: 180,
      // },
      {
        Header: "Impact",
        accessor: "impact",
        width: 100,
      },
      // {
      //   Header: "Frequency",
      //   accessor: "frequency",
      //   width: 100,
      // },
      // {
      // 	Header: "Work Status",
      // 	accessor: "work_status_formatted",
      // 	width: 250,
      // },
      // {
      // 	Header: "Compliance Status",
      // 	accessor: "compliance_status_formatted",
      // 	width: 250,
      // },

      {
        Header: "Executor Name",
        accessor: "executor_name",
        width: 140,
      },
      {
        Header: "Executor Date",
        accessor: "executor_date",
        width: 100,
      },
      {
        Header: "Executor Completion Date",
        accessor: "executor_completion_date",
        width: 180,
      },
      {
        Header: "Executor Comment",
        accessor: "executor_comments",
        width: 180,
      },
      {
        Header: "Legal Due Date",
        accessor: "legal_due_date",
        width: 100,
      },
      // {
      //   Header: "Created Date",
      //   accessor: "created_at",
      //   width: 150,
      // },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   width: 150,
      // },
      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },

      {
        Header: onPrem ? " " : "Reference Document",
        width: onPrem ? 0 : 150,
        Cell: ({ row }: any) => {
          return onPrem ? (
            " "
          ) : (
            <span
              color="primary"
              style={{ color: "rgb(39, 110, 241)" }}
              onClick={(e) => {
                e.stopPropagation();
                getDocumentStoreData(
                  getValue(
                    row,
                    `original.self_compliance.checkpoint.checkpoint_id`,
                    "",
                  ),
                );
              }}
            >
              View Document
            </span>
          );
        },
      },
    ],
    [],
  );
  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    let payload: any = {};
    if (route === "release-to-vendor") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-to-PE") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "add-to-tracker") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-task") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/checkpoint/${route}?${queryRequest}`);
  };

  const handleNavigateDashboard = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    if (getValue(params, `request_type`, "") === "OVER_ALL_COMPLIANCE") {
      navigate(`/dashboard/self-compliance/compliance?${queryRequest}`);
    } else {
      navigate(`/dashboard/self-compliance/my-activity?${queryRequest}`);
    }

    if (getValue(params, `request_from`, "") === "NEW_DASHBOARD") {
      navigate(`/dashboard/self-compliance/my-activity-v2?${queryRequest}`);
    }
  };
  const [permissionLoading, setPermissionLoading] = React.useState(true);
  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    event_id: "",
    sub_event_id: "",
    executor: "",
    evaluator: "",
    function_head: "",
    compliance_status: "",
    status: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setParamsObj({});
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    setFilterVisibility(false);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
      event_id: "",
      sub_event_id: "",
      executor: "",
      evaluator: "",
      function_head: "",
      compliance_status: "",
      status: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
    // setFilterVisibility(false);
  };

  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, ""),
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  const [peComplianceList, setPeComplianceList] = useState([]);
  const getPEComplianceList = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, ""),
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setPeComplianceList(obj);
      } else {
      }
    } catch (error) {}
  };

  /* ---------------------------  Country List  ----------------------------- */
  const getCountriesList = async () => {
    try {
      // let resp = await adminGetCountriesListManagement();
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper(payload);
      let resp = await adminGetSCCountriesListManagement(queryRequest);
      if (resp) {
        setCountryList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `country_id`, ""),
            value: getValue(item, `country_name`, ""),
            label: getValue(item, `country_name`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };

  /* ---------------------------  State List  ----------------------------- */
  const getStatesList = async (countryId: number) => {
    if (countryId) {
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, country: countryId });
      try {
        // let resp = await adminGetStatesListManagement(countryId);
        let resp = await adminGetSCStatesListManagement(queryRequest);
        if (resp) {
          setStates(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `state_id`, ""),
              value: getValue(item, `state_name`, ""),
              label: getValue(item, `state_name`, ""),
            })),
          );
        } else {
        }
      } catch (error) {}
    } else {
      setValue(request, `state_id`, "");
      setRequest({ ...request });
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string,
  ) => {
    if (state_id || getValue(request, `state_id`, "")) {
      setResetInput(false);
      try {
        setResetInput(false);
        setCategoryLawLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          state_id: state_id ? state_id : getValue(request, `state_id`, ""),
          country_id: getValue(request, `country_id`, ""),
          id: id,
        };
        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        let resp = await getSmartFilterSCCategoryOfLawList(queryRequest);
        if (resp) {
          setCategoryOfLawList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `category_of_law_id`, ""),
              // id: getValue(item, `id`, ""),
              value: getValue(item, `category_of_law_text`, ""),
              label: getValue(item, `category_of_law_text`, ""),
            })),
          );
          setCategoryLawLoading(false);
          setValue(request, `category_of_law_id`, "");
        } else {
          setCategoryLawLoading(false);
        }
      } catch (error) {
        setCategoryLawLoading(false);
      }
    } else {
      if (!value) {
        setValue(request, `category_of_law_id`, "");
        setValue(request, `legislation_id`, "");
        setValue(request, `legislation_rule_id`, "");
        setLegislationList([]);
      }
    }
  };
  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    category_of_law_id: string,
    id: string,
  ) => {
    if (category_of_law_id || getValue(request, `category_of_law_id`, "")) {
      try {
        setResetInput(false);
        setLegislationLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          category_of_law_id: category_of_law_id
            ? category_of_law_id
            : getValue(request, `category_of_law_id`, ""),
          state_id: state_id ? state_id : getValue(request, `state_id`, ""),
          id: id,
          country_id: getValue(request, `country_id`, ""),
        };
        let payloadObj = await getPayload();

        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        let resp = await getSmartFilterSCLegislationList(queryRequest);
        if (resp) {
          setLegislationList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `legislation_id`, ""),
              value: getValue(item, `legislation_legislation_name`, ""),
              label: getValue(item, `legislation_legislation_name`, ""),
            })),
          );
          setLegislationLoading(false);
          setValue(request, `id`, "");
        } else {
          setLegislationLoading(false);
        }
      } catch (error) {
        setLegislationLoading(false);
      }
      if (!value) {
        setValue(request, `legislation_id`, "");
        setValue(request, `legislation_rule_id`, "");
        setRuleList([]);
      }
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string,
  ) => {
    if (legislation_id || getValue(request, `legislation_id`, "")) {
      try {
        setResetInput(false);
        setLegislationRuleLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          category_of_law_id: getValue(request, `category_of_law_id`, ""),
          legislation_id: legislation_id
            ? legislation_id
            : getValue(request, `legislation_id`, ""),
          id: id,
          state_id: getValue(request, `state_id`, ""),
          country_id: getValue(request, `country_id`, ""),
        };
        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        // let resp = await getSmartFilterLegislationRuleList(queryRequest);
        let resp = await getSmartFilterSCLegislationRuleList(queryRequest);
        if (resp) {
          setRuleList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `legislation_rule_id`, ""),
              value: getValue(item, `legislation_rule_rule_name`, ""),
              label: getValue(item, `legislation_rule_rule_name`, ""),
            })),
          );
          setLegislationRuleLoading(false);
          setValue(request, `legislation_rule_id`, "");
        } else {
          setLegislationRuleLoading(false);
        }
      } catch (error) {
        setLegislationRuleLoading(false);
      }
      if (!value) {
        setValue(request, `legislation_rule_id`, "");
      }
    }
  };

  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(false);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let payloadObj = await getPayload();
    let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            getValue(paramsObj, `level1`, "").split("_")[1],

            `level${getValue(
              resp,
              `data.entityGroups[${0}].group_level`,
              "",
            )}` === `level1`
              ? ""
              : getValue(paramsObj, `level1`, "").split("_")[0],
            "",
            getValue(paramsObj, `level1`, "").split("_")[2],
          );
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              [],
            ).filter(
              (ite: any) =>
                ite.group_level === parseInt(item.split("_")[2]) + 1,
            );
            return getEntityList(
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              "",
              getValue(findNextLevelInfo, `[${0}].group_level`, ""),
            );
          });
        } else {
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            "",
            getValue(resp, `data.entityGroups[${0}].group_level`, ""),
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string,
    group_level: string,
  ) => {
    if (id) {
      let payload = {
        entity_group: group_level,
        entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
        id: id,
      };
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setChildEntityLoading(true);
      try {
        let resp = await getSCChildEntityGroups(queryRequest);
        if (resp) {
          levelObj[id] = getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `entity_id`, ""),
            value: getValue(item, `entity_name`, ""),
            label: getValue(item, `entity_name`, ""),
          }));
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number,
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          // checkpoint_id: selectedIDs,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getHeaderList(obj, headerIndex);
        // let queryRequest = QueryRequestHelper(obj);
        // navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        let obj = {
          ...paramsObj,
          // checkpoint_id: selectedIDs,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getHeaderList(obj, headerIndex);
        // let queryRequest = QueryRequestHelper(obj);
        // navigate(`${window.location.pathname}?${queryRequest}`);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChangeEntity = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number,
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_",
        )[0]
      : null;

    if (!val) {
      getEntityList(entity_group, entityID, "", parent_level);
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
    } else {
      getEntityList(entity_group, entityID, val, parent_level);
    }
  };

  /* -----------------------------  Executor  ------------------------------ */

  const [executorList, setExecutorList] = useState([]);
  const [executorLoading, setExecutorLoading] = useState(false);
  const [selectedExecutor, setSelectedExecutor] = useState<any>("");
  const getExecutorList = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setExecutorLoading(true);
      let resp = await getExecutorUsers(queryRequest);
      if (resp) {
        setExecutorLoading(false);
        setExecutorList(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `executor_id`, ""),
            value:
              getValue(item, `executor_first_name`, "") +
              " " +
              getValue(item, `executor_last_name`, ""),
            label:
              getValue(item, `executor_first_name`, "") +
              " " +
              getValue(item, `executor_last_name`, ""),
          })),
        );
      } else {
        setExecutorLoading(false);
      }
    } catch (error) {
      setExecutorLoading(false);
    }
    if (!search) {
      setValue(request, `executor`, "");
    }
  };

  /* --------------------------------  Evaluator  ------------------------------ */
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
  const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
  const getEvaluator = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setEvaluatorLoading(true);
      let resp = await getEvaluatorUsers(queryRequest);
      if (resp) {
        setEvaluatorLoading(false);
        setEvaluatorList(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `evaluator_id`, ""),
            value:
              getValue(item, `evaluator_first_name`, "") +
              " " +
              getValue(item, `evaluator_last_name`, ""),
            label:
              getValue(item, `evaluator_first_name`, "") +
              " " +
              getValue(item, `evaluator_last_name`, ""),
          })),
        );
      } else {
        setEvaluatorLoading(false);
      }
    } catch (error) {
      setEvaluatorLoading(false);
    }

    if (!search) {
      setValue(request, `evaluator`, "");
    }
  };
  /* -----------------------------  FunctionHead  ------------------------------ */
  const [FunctionHead, setFunctionHead] = useState([]);
  const [FunctionHeadLoading, setFunctionHeadLoading] = useState(false);
  const [selectedFunctionHead, setSelectedFunctionHead] = useState<any>("");
  const getFunctionHead = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setFunctionHeadLoading(true);
      let resp = await getFunctionHeadUsers(queryRequest);
      if (resp) {
        setFunctionHeadLoading(false);
        setFunctionHead(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `function_head_id`, ""),
            value:
              getValue(item, `function_head_first_name`, "") +
              " " +
              getValue(item, `function_head_last_name`, ""),
            label:
              getValue(item, `function_head_first_name`, "") +
              " " +
              getValue(item, `function_head_last_name`, ""),
          })),
        );
      } else {
        setFunctionHeadLoading(false);
      }
    } catch (error) {
      setFunctionHeadLoading(false);
    }
    if (!search) {
      setValue(request, `function_head`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `id`, "");
        setRequest({
          ...request,
          state_id: "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", e.id, "");
      }
    }
    if (type === "category_of_law_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        setLegislationList([]);
        setRuleList([]);
      } else {
        setRequest({
          ...request,
          category_of_law_id: getValue(e, `id`, "") ? e.id : "",
        });
        getLegislationList("", getValue(request, `state_id`, ""), e.id, "");
      }
    }
    if (type === "legislation_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          legislation_id: "",
          legislation_rule_id: "",
        });
        setRuleList([]);
      } else {
        getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
        setRequest({
          ...request,
          legislation_id: getValue(e, `id`, "") ? e.id : "",
          legislation_rule_id: "",
        });
      }
    }
    if (type === "legislation_rule_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          legislation_rule_id: "",
        });
      } else {
        setRequest({
          ...request,
          legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
        });
      }
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "executor") {
      setRequest({
        ...request,
        executor: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "evaluator") {
      setRequest({
        ...request,
        evaluator: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "function_head") {
      setRequest({
        ...request,
        function_head: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "compliance_status") {
      setRequest({
        ...request,
        compliance_status: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  const handleChangeSelectByValue = (e: object, name: string) => {
    setRequest({
      ...request,
      [name]: getValue(e, `value`, "") ? getValue(e, `value`, "") : "",
    });
  };
  // const handleSubmitSmartFilter = () => {
  //   let selectedSmartFilterIdsPayload = JSON.parse(
  //     JSON.stringify(selectedSmartFilterIds)
  //   );
  //   let levelObj: any = {};
  //   //finding only levels params if it presented in URL
  //   for (let i = 1; i < 11; i++) {
  //     if (getValue(paramsObj, `level${i}`, "")) {
  //       levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
  //     }
  //   }
  //   // if (
  //   // 	getValue(request, `country_id`, "")
  //   // 	// getValue(request, `state_id`, "")
  //   // 	// && getValue(request, `category_of_law_id`, "") &&
  //   // 	// getValue(request, `legislation_id`, "") &&
  //   // 	// getValue(request, `legislation_rule_id`, "")
  //   // ) {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     ...params,
  //     page_no: params.page_no,
  //     country_id: getValue(request, `country_id`, ""),
  //     state_id: getValue(request, `state_id`, ""),
  //     category_of_law_id: getValue(request, `category_of_law_id`, ""),
  //     legislation_id: getValue(request, `legislation_id`, ""),
  //     legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
  //     search_text: getValue(params, `search_text`, ""),
  //     limit: getValue(params, `limit`, ""),
  //     event_id: getValue(request, `event_id`, ""),
  //     sub_event_id: getValue(request, `sub_event_id`, ""),
  //     executor: getValue(request, `executor`, ""),
  //     evaluator: getValue(request, `evaluator`, ""),
  //     function_head: getValue(request, `function_head`, ""),
  //     compliance_status: getValue(request, `compliance_status`, ""),
  //     smart_filter_tags:
  //       selectedSmartFilterIdsPayload.length > 0
  //         ? selectedSmartFilterIdsPayload.map((item: object) =>
  //             getValue(item, `id`, "")
  //           )
  //         : [],
  //     status: getValue(request, `status`, ""),
  //   };
  //   let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
  //   navigate(`${window.location.pathname}?${queryRequest}`);
  //   handleFilter();
  //   // } else {
  //   // 	toast.error("All fields are mandatory");
  //   // }
  // };

  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds),
    );
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: params.page_no,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      event_id: getValue(request, `event_id`, ""),
      sub_event_id: getValue(request, `sub_event_id`, ""),
      executor: getValue(request, `executor`, ""),
      evaluator: getValue(request, `evaluator`, ""),
      function_head: getValue(request, `function_head`, ""),
      compliance_status: getValue(request, `compliance_status`, ""),
      status: getValue(request, `status`, ""),
      smart_filter_tags:
        selectedSmartFilterIdsPayload.length > 0
          ? selectedSmartFilterIdsPayload.map((item: object) =>
              getValue(item, `id`, ""),
            )
          : [],
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, ""),
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, ""),
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, ""),
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, ""),
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") ==
        getValue(request, `legislation_rule_id`, ""),
    );
  let executor_ID =
    getValue(executorList, `length`, 0) > 0 &&
    executorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `executor`, ""),
    );
  let evaluator_ID =
    getValue(evaluatorList, `length`, 0) > 0 &&
    evaluatorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `evaluator`, ""),
    );
  let function_head_ID =
    getValue(FunctionHead, `length`, 0) > 0 &&
    FunctionHead.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `function_head`, ""),
    );
  let compliance_status_ID =
    getValue(complianceStatusOptions, `length`, 0) > 0 &&
    complianceStatusOptions.filter(
      (item: object) =>
        getValue(item, `value`, "") ==
        getValue(request, `compliance_status`, ""),
    );
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await bulkUpdateSelfComplianceTask({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* ---------------------------  Update Modal  ----------------------------- */
  const [selectedObj, setSelectedObj] = useState({});
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const handleUpdateTask = () => {
    setShowUpdatePopup(!showUpdatePopup);
    let findOne =
      getValue(list, `length`, 0) > 0
        ? list.filter(
            (item) =>
              getValue(item, `id`, "") === getValue(selectedIDs, `[${0}]`, ""),
          )
        : [];
    if (getValue(selectedIDs, `length`, 0) === 1) {
      setSelectedObj(getValue(findOne, `[${0}]`, {}));
      // if (getValue(findOne, `length`, 0) > 0) {
      setSelfCompliance({
        ...selfCompliance,
        completion_date: getValue(findOne, `[${0}].completion_date`, null)
          ? NewDate(getValue(findOne, `[${0}].completion_date`, null))
          : new Date(),
        compliance_status: getValue(findOne, `[${0}].compliance_status`, null),
        work_status: getValue(findOne, `[${0}].work_status`, null),
        remarks: getValue(findOne, `[${0}].remarks`, null),
        non_compliance_reason: getValue(
          findOne,
          `[${0}].non_compliance_reason`,
          null,
        ),
        event_not_occured: getValue(findOne, `[${0}].event_not_occured`, false),
        document_ids: getValue(findOne, `[${0}].documents`, []),
        evaluator_comments: getValue(
          findOne,
          `[${0}].evaluator_comments`,
          "",
        ),
        is_required_reason_for_non_compliance: getValue(
          findOne,
          `[${0}].is_required_reason_for_non_compliance`,
          getValue(
            selfCompliance,
            `is_required_reason_for_non_compliance`,
            false,
          ),
        ),
      });
      setUpdateId(getValue(findOne, `[${0}].self_compliance.id`, null));
      // }
    } else {
      setSelfCompliance({
        ...selfCompliance,
        // completion_date: new Date(),
        compliance_status: "AWAITING_APPROVAL",
        work_status: "",
        remarks: "",
        non_compliance_reason: "",
        event_not_occured: false,
        document_ids: [],
        approval_status: "PENDING",
      });
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first: any = convertDate(from_date);
    let last: any = convertDate(to_date);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Update Popup                               */
  /* -------------------------------------------------------------------------- */

  const [selfCompliance, setSelfCompliance] = useState<any>({
    completion_date: "",
    compliance_status: "",
    // work_status: "",
    remarks: "",
    non_compliance_reason: "",
    event_not_occured: false,
    document_ids: [],
    evaluator_comments: "",
  });
  const [updateId, setUpdateId] = useState("");

  const [complianceStatusList] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "PENDING_FOR_APPROVAL", label: "Pending For Approval" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
  ]);
  // const handleUploadDocuments = async (e: any) => {
  // 	Array.from(e).forEach(async (item: any) => {
  // 		let formData = new FormData();
  // 		formData.append("file", item);
  // 		try {
  // 			let resp = await clientAdminFileUpload(formData);
  // 			if (resp) {
  // 				getValue(selfCompliance, `document_ids`, "").push(
  // 					getValue(resp, `data`, {})
  // 				);

  // 				setSelfCompliance({ ...selfCompliance });
  // 				e = null;
  // 			} else {
  // 				e = null;
  // 			}
  // 		} catch (error) {
  // 			e = null;
  // 		}
  // 	});
  // };
  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleSubmitTask = async (status: string) => {
    try {
      setSubmitLoading(true);
      setSelectedStatus(status);
      let obj = JSON.parse(JSON.stringify(selfCompliance));
      if (status === "APPROVED") {
        obj["approval_status"] = status ? status : "APPROVED";
        // obj["compliance_status"] = "COMPLIED";
      } else {
        obj["compliance_status"] = status ? status : "RE_OPENED";
      }
      obj["document_ids"] =
        getValue(selfCompliance, `document_ids.length`, 0) > 0
          ? getValue(selfCompliance, `document_ids`, []).map(
              (item: object) => ({
                id: getValue(item, `id`, ""),
              }),
            )
          : [];
      const completionDate = new Date(
        getValue(selfCompliance, `completion_date`, ""),
      );
      const legalDueDate = new Date(
        getValue(selectedObj, `legal_due_date`, ""),
      );
      const isEvaluatorCommentRequiredForEventNotOccurred =
        getValue(selfCompliance, `event_not_occured`, false) &&
        new Date(new Date().toDateString()) >
          new Date(legalDueDate.toDateString()) &&
        getValue(
          selfCompliance,
          `is_required_reason_for_non_compliance`,
          false,
        );

      if (
        isEvaluatorCommentRequiredForEventNotOccurred &&
        !String(getValue(selfCompliance, `evaluator_comments`, "")).trim()
      ) {
        toast.error(
          "Please provide Evaluator Comments when the event did not occur",
        );
        setSubmitLoading(false);
        return;
      }

      if (
        completionDate > legalDueDate &&
        !getValue(selfCompliance, `evaluator_comments`, "")
      ) {
        toast.error(
          "The Completion Date is greater than Legal Due Date! Please provide your comments",
        );
        setSubmitLoading(false);
      } else {
        if (completionDate > legalDueDate) {
          handleConfirmModal();
        } else {
          let resp;
          if (getValue(selectedIDs, `length`, 0) > 1) {
            // delete obj["completion_date"];
            // obj["self_compliance_task_ids"] = selectedIDs;
            const mutableObj = { ...obj }; // Create a shallow copy
            delete mutableObj["completion_date"]; // Remove the field
            mutableObj["self_compliance_task_ids"] = selectedIDs; // Add task IDs
            resp = await UpdateMultipleSelfComplianceTask(mutableObj);
          } else {
            // delete obj["completion_date"];
            // const mutableObj = { ...obj }; // Create a shallow copy
            // delete mutableObj["completion_date"]; // Remove the field
            resp = await UpdateSelfComplianceTask(selectedIDs[0], obj);
          }
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setSubmitLoading(false);
            setShowUpdatePopup(false);
            setSelectedIDs([]);
            setSelfCompliance({
              ...selfCompliance,
              completion_date: "",
              compliance_status: "",
              work_status: "",
              remarks: "",
              non_compliance_reason: "",
              evaluator_comments: "",
              event_not_occured: false,
              document_ids: [],
            });
            setUpdateId("");
            getData();
            setSelectedStatus("");
          } else {
            setSubmitLoading(false);
            setSelectedStatus("");
          }
        }
      }
    } catch (error) {
      setSubmitLoading(false);
      setSelectedStatus("");
    }
  };

  /* -------------------------  Upload Document  ------------------------------ */

  const removeDocument = (id: string) => {
    let filtered =
      getValue(selfCompliance, `document_ids.length`, 0) > 0
        ? getValue(selfCompliance, `document_ids`, []).filter(
            (item: any) => item.id !== id,
          )
        : [];
    setSelfCompliance({
      ...selfCompliance,
      document_ids: filtered,
    });
  };
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    // e.preventDefault();
    Array.from(e).forEach(async (item: any, index: number) => {
      let formData = new FormData();
      formData.append("file", item);
      setUploadLoading(true);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e = null;
        } else {
          e = null;
        }
      } catch (error) {
        e = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};
  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      ...(params.is_all_time === "true"
        ? { report_name: "All Pending Tasks", show_till_date: true }
        : {
            from_date: convertDate(from_date),
            to_date: convertDate(to_date),
            report_name: (
              convertDateAsString(from_date) +
              " " +
              "to" +
              " " +
              convertDateAsString(to_date)
            ).toString(),
          }),
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      // search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // category_of_law_id: await getSpecificCategoryLawById(
      //   getValue(params, `category_of_law_id`, "")
      // ),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
      smart_filter_tags: selectedIDs,
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      report_type: "SELFCOMP_PENDING_APPROVAL",
      status: getValue(params, `status`, "")
        ? getValue(params, `status`, "")
        : "active",
      compliance_status: getValue(params, `compliance_status`, ""),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_",
        )[0];
      }
    }
    // let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    setDownloadLoading(true);
    try {
      let resp = await downloadSelfComplianceReports({
        ...payload,
        ...levelObj,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/SELFCOMP_PENDING_APPROVAL`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/SELFCOMP_PENDING_APPROVAL`);
  };

  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = urlParamsFun();
  const handleChangeSelectByDirectValue = (value: string, name: string) => {
    setRequest({
      ...request,
      [name]: value ? value : "",
    });
  };
  let route = window.location.pathname.split("/");
  // const urlSearchParams = new URLSearchParams(window.location.search);
  // const params = Object.fromEntries(urlSearchParams.entries());
  const [documentStoreIsOpen, setDocumentStoreIsOpen] = useState(false);
  const handleDocumentStore = () => {
    setDocumentStoreIsOpen(!documentStoreIsOpen);
  };

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmModal = () => {
    setConfirmOpen(!confirmOpen);
  };

  const handleSubmitConfirmModalTask = async () => {
    try {
      setSubmitLoading(true);
      let obj = JSON.parse(JSON.stringify(selfCompliance));
      if (selectedStatus === "APPROVED") {
        obj["approval_status"] = selectedStatus ? selectedStatus : "APPROVED";
        // obj["compliance_status"] = "COMPLIED";
      } else {
        obj["compliance_status"] = selectedStatus
          ? selectedStatus
          : "RE_OPENED";
      }
      obj["document_ids"] =
        getValue(selfCompliance, `document_ids.length`, 0) > 0
          ? getValue(selfCompliance, `document_ids`, []).map(
              (item: object) => ({
                id: getValue(item, `id`, ""),
              }),
            )
          : [];
      const completionDate = new Date(
        getValue(selfCompliance, `completion_date`, ""),
      );
      const legalDueDate = new Date(
        getValue(selectedObj, `legal_due_date`, ""),
      );

      if (
        completionDate > legalDueDate &&
        !getValue(selfCompliance, `evaluator_comments`, "")
      ) {
        toast.error(
          "The Completion Date is greater than Legal Due Date! Please provide your comments",
        );
      } else {
        let resp;
        if (getValue(selectedIDs, `length`, 0) > 1) {
          // obj["self_compliance_task_ids"] = selectedIDs;
          const mutableObj = { ...obj }; // Create a shallow copy
          delete mutableObj["completion_date"]; // Remove the field
          mutableObj["self_compliance_task_ids"] = selectedIDs; // Add task IDs
          resp = await UpdateMultipleSelfComplianceTask(mutableObj);
        } else {
          // const mutableObj = { ...obj }; // Create a shallow copy
          // delete mutableObj["completion_date"]; // Remove the field
          resp = await UpdateSelfComplianceTask(selectedIDs[0], obj);
        }
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          setShowUpdatePopup(false);
          setSelectedIDs([]);
          setSelfCompliance({
            ...selfCompliance,
            completion_date: "",
            compliance_status: "",
            work_status: "",
            remarks: "",
            non_compliance_reason: "",
            evaluator_comments: "",
            event_not_occured: false,
            document_ids: [],
          });
          setUpdateId("");
          handleConfirmModal();
          getData();
          setSelectedStatus("");
        } else {
          setSubmitLoading(false);
          setSelectedStatus("");
        }
      }
    } catch (error) {
      setSubmitLoading(false);
      setSelectedStatus("");
    }
  };

  const handleCheckEvaluatorDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {};
    if (getValue(params, `is_evaluator_date`, "")) {
      delete params["is_evaluator_date"];
      payload = {
        ...params,
        page_no: 1,
      };
    } else {
      payload = {
        ...params,
        is_evaluator_date: true,
      };
    }

    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!getValue(params, `is_evaluator_date`, "")) {
      getData();
    }
  };

  const handleCheckAlltime = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any;
    if (params.is_all_time === "true") {
      delete params["is_all_time"];
      payload = { ...params, page_no: 1 };
    } else {
      payload = { ...params, is_all_time: "true", page_no: 1 };
    }
    let queryRequest2 = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest2}`);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "activities_self_compliance_evaluator_approval",
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              // isMarkInactiveSectionVisible={true}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              handleRemoveNavItems={handleRemoveNavItems}
              handleNavigate={handleNavigate}
              permissions={props.permissions}
              licenseIDs={licenseIDs}
              // assignTask
              masterNav={"false"}
              // multi={true}
              // isUpdateTaskVisible={
              //   true
              //   // getValue(selectedIDs, `length`, 0) === 1 ? true : false
              // }
              isUpdateTaskVisible={
                (getValue(props, `permissions`, []).includes("bulk_update") &&
                  getValue(selectedIDs, `length`, 0) > 1) ||
                getValue(selectedIDs, `length`, 0) === 1
                  ? true
                  : false
              }
              showUpdatePopup={handleUpdateTask}
            />
          )}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <div className="d-flex align-items-center">
              {getValue(params, `request_type`, "") && (
                <div
                  onClick={handleNavigateDashboard}
                  className="cursor-pointer"
                >
                  <img
                    src="/images/back-link.svg"
                    className="img-fluid add-filter-wrapper__upload-image"
                  />
                  &nbsp;&nbsp;&nbsp;
                </div>
              )}
              <h4 className="dashbaord-wrapper__header-title">
                Pending Approval
              </h4>
            </div>
            <div className="d-flex align-items-center">
              <h6
                className="mx-3 header_text__blue cursor-pointer"
                onClick={() =>
                  navigate(
                    `/activities/self-compliance/pending-approval/my-tasks?${mainQueryRequest}`,
                  )
                }
              >
                Mapped Tasks
              </h6>
              <div className="filter-form-wrappper__container d-flex">
                <DatePicker
                  selectsRange={true}
                  startDate={from_date}
                  endDate={to_date}
                  className="react-date-picker__inputGroup__input"
                  onChange={(update: any) => {
                    handleDate(update);
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
                <button
                  className="dashboard-wrapper__apply-btn"
                  onClick={handleSubmitDate}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              {getValue(params, `request_type`, "") && (
                <div
                  onClick={handleNavigateDashboard}
                  className="cursor-pointer"
                >
                  <img
                    src="/images/back-link.svg"
                    className="img-fluid add-filter-wrapper__upload-image"
                  />
                  &nbsp;&nbsp;&nbsp;
                </div>
              )}

              <div className="header-parent-icon-holder">
                <MenuActivitySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Self Compliance
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Evaluator Approval
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              {/* <div className="d-flex align-items-center mx-2">
                  <h4 className="header_text__blue">Switch to Evaluator Date</h4>
                  <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={getValue(params, `is_evaluator_date`, "") ? true : false}
                        onChange={() => handleCheckEvaluatorDate()}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div> */}

              <RightMenuHeaders
                // selfComplianceMappedTasksEvaluator={true}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleSubmitDate={handleSubmitDate}
                // all time toggle
                allTime={true}
                handleCheckAlltime={handleCheckAlltime}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                //logs section
                viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper has-module-filter`}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  isFilterVisible={isFilterVisible}
                  filterCompliance
                  peComplianceList={peComplianceList}
                  handleChangeStatus={handleChangeStatus}
                  //self-compliance download section
                  downloadSelfComplianceReport={true}
                  viewDownloadedSelfComplianceReports={true}
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                  downloadLoading={downloadLoading}
                  handleNavigateLogs={handleNavigateLogs}
                  //----> Compliance Status
                  compliance_status_ID={compliance_status_ID}
                  complianceStatusOptions={complianceStatusOptions}
                  handleChangeSelectByValue={handleChangeSelectByValue}
                  filterComplianceStatus
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div>
              <div>
                <ModuleFilter
                  filterCompliance
                  peComplianceList={peComplianceList}
                  handleChangeStatus={handleChangeStatus}
                  compliance_status_ID={compliance_status_ID}
                  complianceStatusOptions={complianceStatusOptions}
                  handleChangeSelectByValue={handleChangeSelectByValue}
                  filterComplianceStatus
                />
              </div>
              {/* {isFilterVisible && ( */}
              <AssignTaskFilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                additionalFilter={true}
                country_ID={country_ID}
                state_ID={state_ID}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                events={true}
                request={request}
                //dynamic filter ( Custom Input Select Dropdown)
                //----> category of law
                categoryOfLawList={categoryOfLawList}
                getCategoryLawList={getCategoryLawList}
                categoryLawLoading={categoryLawLoading}
                cat_ID={cat_ID}
                //----> legislation
                legislationList={legislationList}
                getLegislationList={getLegislationList}
                legislationLoading={legislationLoading}
                leg_ID={leg_ID}
                //----> legislation rule
                ruleList={ruleList}
                getLegislationRuleList={getLegislationRuleList}
                rule_ID={rule_ID}
                legislationRuleLoading={legislationRuleLoading}
                resetInput={resetInput}
                //-----> Entity Mapping Filter
                headerList={headerList}
                headerLoading={headerLoading}
                levelObj={levelObj}
                childEntityLoading={childEntityLoading}
                handleClickEntity={handleClickEntity}
                urlParams={paramsObj}
                handleChangeEntity={handleChangeEntity}
                //----> Executor
                executorList={executorList}
                executor_ID={executor_ID}
                executorLoading={executorLoading}
                getExecutorList={getExecutorList}
                //----> Evaluator
                evaluator_ID={evaluator_ID}
                evaluatorList={evaluatorList}
                EvaluatorLoading={EvaluatorLoading}
                getEvaluator={getEvaluator}
                //----> Function Head
                function_head_ID={function_head_ID}
                FunctionHead={FunctionHead}
                FunctionHeadLoading={FunctionHeadLoading}
                getFunctionHead={getFunctionHead}
                //----> Compliance Status
                compliance_status_ID={compliance_status_ID}
                complianceStatusOptions={[complianceStatusOptions]}
                handleChangeSelectByValue={handleChangeSelectByValue}
                // compliance_status_filter
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Self Compliance"}
                subModuleName={"Evaluator Approval"}
                hideActive
                handleChangeSelectByDirectValue={
                  handleChangeSelectByDirectValue
                }
                params={params}
              />
              {/* )} */}

              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableDataTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      {/* <EvaluatorApprovalNotfound /> */}
                      <ActivitiesEvaluatorTaskNotfound
                        hasLegacyTask={hasLegacyTask}
                      />
                    </>
                  ) : (
                    <ActivitiesEvaluatorTaskNotfound
                      hasLegacyTask={hasLegacyTask}
                    />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
      {/* complete task popup */}
      <SelfComplianceUpdatePopup
        showUpdatePopup={showUpdatePopup}
        setShowUpdatePopup={setShowUpdatePopup}
        selfCompliance={selfCompliance}
        setSelfCompliance={setSelfCompliance}
        handleUploadDocuments={handleUploadDocuments}
        handleSubmitTask={handleSubmitTask}
        submitLoading={submitLoading}
        complianceStatusList={complianceStatusList}
        permissions={getValue(props, `permissions`, [])}
        selectedStatus={selectedStatus}
        selectedObj={selectedObj}
        removeDocument={removeDocument}
        handleDrop={handleDrop}
        uploadLoading={uploadLoading}
        handleDragOver={handleDragOver}
        disableUpload={disableUpload}
        selectedIDs={selectedIDs}
        type={"pending_approval"}
        sub_route={route[3]}
      />

      <DocumentStorePopup
        docStoreData={docStoreData}
        documentStoreIsOpen={documentStoreIsOpen}
        handleDocumentStore={handleDocumentStore}
      />

      <ConfirmModalTask
        isOpen={confirmOpen}
        handleModal={handleConfirmModal}
        handleSubmit={handleSubmitConfirmModalTask}
      />
    </DashboardLayout>
  );
};
export default ActivitiesPendingApprovalTask;
